// extracted by mini-css-extract-plugin
export var cancelButton = "_o6-5";
export var content = "_o6-3";
export var createButton = "_o6-6";
export var drawerContainer = "_o6-0";
export var footer = "_o6-2";
export var header = "_o6-1";
export var orderFormColumn = "_o6-4";